import { Link } from 'react-router-dom';

import Button from '~/ui/components/common/Button';

import type { ILocalAdminFormProps } from '../types';

import styles from '../Form.module.scss';

interface FormFooterProps {
  cancelLinkTo: ILocalAdminFormProps['cancelLinkTo'];
  isProcessing: boolean;
  submitText: string;
  isValid: boolean;
}

const FormFooter = ({ cancelLinkTo, isProcessing, submitText, isValid }: FormFooterProps) => (
  <div className={styles.buttonsWrapper}>
    <div className={styles.buttonWrapper}>
      <Link to={cancelLinkTo} className={styles.link}>
        <Button variant="outlined" color="primary" disabled={isProcessing}>
          Cancel
        </Button>
      </Link>
    </div>
    <Button variant="contained" color="primary" type="submit" disabled={isProcessing || !isValid}>
      {submitText}
    </Button>
  </div>
);

export default FormFooter;
